import { createStore } from 'vuex'
import { defaultLang } from '@/config/lang'
import { getUser, setUser, getActUserInfo, setActUserInfo, getHistoryAccount, setHistoryAccount } from '@/utils'
import wcAct from './modules/wcAct'
import annAct from './modules/annAct'

export default createStore({
  state: {
    locale: defaultLang,
    cpUserInfo: getUser(),
    historyAccount: getHistoryAccount(),
    actUserInfo: getActUserInfo(),
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale
    },
    SET_CP_USER_INFO(state, cpUserInfo) {
      setUser(cpUserInfo)
      state.cpUserInfo = cpUserInfo
      if (cpUserInfo.cpUserId) {
        this.commit('SET_HISTORY_ACCOUNT', cpUserInfo)
      }
    },
    SET_HISTORY_ACCOUNT(state, cpUserInfo) {
      setHistoryAccount(cpUserInfo)
      state.historyAccount = getHistoryAccount()
    }
    ,
    SET_ACT_USER_INFO(state, actUserInfo) {
      setActUserInfo(actUserInfo)
      state.actUserInfo = actUserInfo
    },
  },
  actions: {
  },
  modules: {
    wcAct,
    annAct,
  }
})
